module.exports = __webpack_public_path__ + "img/movein.0cef6d72.png";